export enum OrderShipmentStatus {
  LOADING = 'loading',
  ON_ROUTE = 'onRoute',
  DELIVERED = 'delivered',
}
